'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotFoundError = exports.InternalServerError = exports.FatalError = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _es6Error = require('es6-error');

var _es6Error2 = _interopRequireDefault(_es6Error);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FatalError = function (_ExtendableError) {
  _inherits(FatalError, _ExtendableError);

  function FatalError(message) {
    _classCallCheck(this, FatalError);

    return _possibleConstructorReturn(this, (FatalError.__proto__ || Object.getPrototypeOf(FatalError)).call(this, message));
  }

  return FatalError;
}(_es6Error2.default);

var NotFoundError = function (_FatalError) {
  _inherits(NotFoundError, _FatalError);

  function NotFoundError(props) {
    _classCallCheck(this, NotFoundError);

    var _this2 = _possibleConstructorReturn(this, (NotFoundError.__proto__ || Object.getPrototypeOf(NotFoundError)).call(this, props));

    _this2.status = 404;
    return _this2;
  }

  _createClass(NotFoundError, [{
    key: 'getStatus',
    value: function getStatus() {
      return this.status;
    }
  }]);

  return NotFoundError;
}(FatalError);

var InternalServerError = function (_FatalError2) {
  _inherits(InternalServerError, _FatalError2);

  function InternalServerError(props) {
    _classCallCheck(this, InternalServerError);

    var _this3 = _possibleConstructorReturn(this, (InternalServerError.__proto__ || Object.getPrototypeOf(InternalServerError)).call(this, props));

    _this3.status = 500;
    return _this3;
  }

  _createClass(InternalServerError, [{
    key: 'getStatus',
    value: function getStatus() {
      return this.status;
    }
  }]);

  return InternalServerError;
}(FatalError);

exports.FatalError = FatalError;
exports.InternalServerError = InternalServerError;
exports.NotFoundError = NotFoundError;


/*****************
 ** WEBPACK FOOTER
 ** ./src/lib/custom-error.js
 ** module id = 213
 ** module chunks = 0
 **/